import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, onOkClick, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {children}
        <button className="modal-close modal-ok-button" onClick={onOkClick || onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Modal;
